// src/components/scenes/SearchScene.js
// Filepath: // src/components/scenes/SearchScene.js
import React from "react";
import { Box, Stack, TextField } from "@mui/material";
import GridScene from "./GridScene";
import { useState } from "react";

export default function SearchScene() {
  const [q, setQ] = useState("");

  return (
    <Box sx={{ width: "100%", height: "100%", p: 3 }}>
      <Stack spacing={2}>
        <TextField
          label="Search"
          placeholder="Type and press Enter"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              // Nothing else needed; GridScene below reads q from state
            }
          }}
        />
        {/* Results */}
        <GridScene source="search" query={q} title={q ? `Search: ${q}` : "Search"} />
      </Stack>
    </Box>
  );
}
